import { motion } from "framer-motion";
import { FadeUp } from "@/components/Reveal";

const works = [
  { src: "/assets/vgraphics/grand-hyatt.webp", label: "Architectural Signs" },
  { src: "/assets/vgraphics/banner-witcoff.webp", label: "Retail Graphics & Displays" },
  { src: "/assets/vgraphics/backdrops.webp", label: "Event Backdrops" },
  { src: "/assets/vgraphics/stage-wrap.webp", label: "Stage Wraps" },
];

export default function VGraphics() {
  return (
    <section id="vgraphics" data-testid="vgraphics-section" className="relative bg-ivory py-32 sm:py-44 overflow-hidden">
      <div className="absolute -top-24 left-1/3 w-[460px] h-[460px] rounded-full bg-gold/10 blur-[120px]" aria-hidden="true" />
      <div className="max-w-[1200px] mx-auto px-6 sm:px-10 relative">
        <FadeUp className="mb-6 text-center">
          <p className="text-[12px] tracking-[0.45em] uppercase text-coral">Beyond the Floor</p>
        </FadeUp>
        <FadeUp delay={0.1}>
          <p data-testid="vgraphics-quote" className="font-quote italic text-xl sm:text-2xl text-ink/70 max-w-3xl mx-auto leading-relaxed text-center mb-12">
            And the magic doesn't stop at the floor. Through our exclusive partnership
            with V-Graphics, we can custom-brand your entire event — from Wrapped Bars
            to Architectural Signage and Beyond.
          </p>
        </FadeUp>
        <FadeUp delay={0.2} className="flex justify-center mb-16 sm:mb-20">
          <div className="bg-white rounded-2xl px-8 py-5 shadow-[0_20px_50px_-20px_rgba(45,40,51,0.25)]">
            <img
              src="/assets/vgraphics/vgraphics-logo.webp"
              alt="V-Graphics — architectural signs, retail graphics and displays, large format printing, vehicle wraps"
              data-testid="vgraphics-logo"
              className="h-16 sm:h-20 w-auto"
              loading="lazy"
            />
          </div>
        </FadeUp>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">
          {works.map((w, i) => (
            <FadeUp key={w.src} delay={i * 0.08} className="group relative overflow-hidden rounded-[1.5rem] spotlight-frame aspect-[4/5]">
              <motion.img
                src={w.src}
                alt={w.label}
                loading="lazy"
                className="w-full h-full object-cover"
                whileHover={{ scale: 1.06 }}
                transition={{ duration: 1.1, ease: [0.22, 1, 0.36, 1] }}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-midnight/55 via-transparent to-transparent" />
              <p className="absolute bottom-4 left-5 right-3 text-ivory text-[11px] tracking-[0.25em] uppercase">
                {w.label}
              </p>
            </FadeUp>
          ))}
        </div>
      </div>
    </section>
  );
}
